import React from "react";
import { Link } from "react-router-dom";

// Compact summary card for a policy in the library grid.
export default function PolicyCard({ policy }) {
  const approved = !!policy.current_version_id;
  return (
    <Link
      to={`/compliance/mvp/policies/${policy.slug}`}
      className="block rounded-lg border border-slate-200 p-4 hover:border-indigo-400 hover:shadow-sm transition"
      data-testid="policy-card"
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="font-medium text-slate-800">{policy.title}</h3>
        <span
          className={`shrink-0 rounded px-2 py-0.5 text-xs ${
            approved ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"
          }`}
        >
          {approved ? "approved" : "draft"}
        </span>
      </div>
      <p className="mt-1 text-xs text-slate-500">{policy.slug}</p>
      {policy.category && (
        <p className="mt-2 text-xs uppercase tracking-wide text-slate-400">{policy.category}</p>
      )}
    </Link>
  );
}
